const fetchPrices = async (item) => {
  const response = await fetch(`/products/${item.handle}?view=wizard-price`);
  const prices = await response.json();
  return prices;
};

const fetchCart = async () => {
  const response = await fetch('/cart.js');
  return await response.json();
}

const changeCart = async ({ item, bundleData }) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: item.key,
      properties: {
        ...item.properties,
        _bundleData: JSON.stringify(bundleData),
        _useNewKey: true
      }
    })
  })

  return await response.json();
}

const regenerateKitUniqueId = (bundleData) => {
  const poolProduct = bundleData.items.find(item => item.main === 1);
  const kitUniqueId = `10${bundleData.items.length}${bundleData.items.length * poolProduct.handle.length - 78}`;

  return kitUniqueId;
}

const validateBundle = async (item) => {
  const bundleData = JSON.parse(item.properties._bundleData);

  for (let i = 0; i < bundleData.items.length; i++) {
    const bundleItem = bundleData.items[i];
    const { price, wizardPrice } = await fetchPrices(bundleItem);
    if (bundleItem.main === 1) {
      bundleItem.pr = price / 100;
      continue;
    }
    bundleItem.pr = wizardPrice;
  }

  bundleData._kitUniqId = regenerateKitUniqueId(bundleData);;
  await changeCart({ item, bundleData });
}

const bundleDataValidator = async () => {
  const cart = await fetchCart();
  const poolItems = cart.items.filter(item => item.properties._bundleData !== undefined);

  for (let i = 0; i < poolItems.length; i++) {
    const item = poolItems[i];
    await validateBundle(item);
  }
}

bundleDataValidator();

setInterval(bundleDataValidator, 900000); // 15 minutes
